import { useDispatch } from "react-redux";

export default () => {
	const dispatch = useDispatch();

	const setError = (error : any) => {
		dispatch({ type: "SET_ERROR", error });
	};

	return setError;
}
